import { render, staticRenderFns } from "./CourseAppointmentBranchPicker.vue?vue&type=template&id=8654f2a8&"
import script from "./CourseAppointmentBranchPicker.vue?vue&type=script&lang=js&"
export * from "./CourseAppointmentBranchPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports